import Cookies from 'js-cookie';

/**
 * Remove o cookie de sessão nas duas formas em que ele pode ter sido gravado: no host atual e no
 * domínio `.inclui...` (cookie compartilhado entre subdomínios) — a mesma limpeza que a tela de login faz.
 */
const clearSessionCookie = () => {
	Cookies.remove('token');

	const { hostname } = window.location;
	const sharedDomain = hostname.includes('inclui') ? hostname.slice(hostname.indexOf('inclui')) : hostname;
	Cookies.remove('token', { domain: '.' + sharedDomain });
};

export default clearSessionCookie;
